var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.DateModal, {
    attrs: { value: _setup.isDialogOpened },
    on: {
      input: _setup.handleCloseModal,
      "click:submit": _setup.applySelectedDate,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }